import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface BackendErrorPageProps {
    error: string;
}

const BackendErrorPage = ({ error }: BackendErrorPageProps) => {
    return (
        <div className="flex flex-col items-center justify-center h-full w-full p-6">
            <div className="bg-red-50 border border-red-200 rounded-lg p-8 w-full max-w-2xl flex flex-col">
                <div className="flex items-center gap-4 mb-4">
                    <ExclamationTriangleIcon className="h-12 w-12 text-red-500 flex-shrink-0" />
                    <div>
                        <h1 className="text-2xl font-bold text-red-700">Backend Service Unavailable</h1>
                        <p className="text-red-600 mt-1">Unable to connect to the backend services</p>
                    </div>
                </div>

                <div className="overflow-y-auto h-64 mb-4">
                    <div className="bg-white rounded p-4 mb-4">
                        <p className="text-sm text-gray-700 mb-2">
                            The application cannot connect to the required backend services. This may be due to:
                        </p>
                        <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-2">
                            <li>InfluxDB database is not running or unreachable</li>
                            <li>Backend API server is down</li>
                            <li>Network connectivity issues</li>
                        </ul>
                    </div>

                    <details className="bg-gray-50 rounded p-4">
                        <summary className="cursor-pointer text-sm font-semibold text-gray-700 hover:text-gray-900">
                            Error Details
                        </summary>
                        <pre className="mt-3 text-xs text-gray-600 overflow-auto whitespace-pre-wrap break-words max-h-32">
                            {error}
                        </pre>
                    </details>
                </div>

                <div className="flex-shrink-0">
                    <button
                        onClick={() => window.location.reload()}
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                    >
                        Retry Connection
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BackendErrorPage;
